import { tableObject } from "./FeaturesComponents";

import timeSeriesData from '../../../../../assets/analytics/time_series_data.png';
// import timeSeriesData from '../../../../assets/analytics/time-series.png';
import statistics from '../../../../../assets/analytics/statistics.png';
import tidalLevels from '../../../../../assets/analytics/tidal-levels.png';
import scatterPlot from '../../../../../assets/analytics/scatter-plot.png';
import scatterTable from '../../../../../assets/analytics/scatter-table.png';
import rosePlot from '../../../../../assets/analytics/rose-plot.png';
import exceedance from '../../../../../assets/analytics/exceedance.png';
import histogram from '../../../../../assets/analytics/histogram.png';
import persistence from '../../../../../assets/analytics/persistence.png';
import extremeValues from '../../../../../assets/analytics/extreme-values.png';

import extreamValuesFile from '../../../../../assets/analytics/Example_Extreme_Values_EVA.xlsx';
import noramlSeaStatesFile from '../../../../../assets/analytics/Example_Normal_Sea_States_NSS.xlsx';

export const analyticsTable: tableObject[] = [
    {
        text: '1. Time Series',
        image: {
            src: timeSeriesData,
            alt: ''
        },
    },
    {
        text: '2. Statistics',
        image: {
            src: statistics,
            alt: ''
        },
    },
    {
        text: '3. Tidal levels',
        image: {
            src: tidalLevels,
            alt: ''
        },
    },
    {
        text: '4. Scatter plot',
        image: {
            src: scatterPlot,
            alt: ''
        },
    },
    {
        text: '5. Scatter table',
        image: {
            src: scatterTable,
            alt: ''
        },
    },
    {
        text: '6. Rose plot',
        image: {
            src: rosePlot,
            alt: ''
        },
    },
    {
        text: '7. Exceedance',
        image: {
            src: exceedance,
            alt: ''
        },
    },
    {
        text: '8. Histogram (Weibull fit)',
        image: {
            src: histogram,
            alt: ''
        },
    },
    {
        text: '9. Persistence (Weather windows)',
        image: {
            src: persistence,
            alt: ''
        },
    },
    {
        text: '10. Extreme values (EVA)',
        image: {
            src: extremeValues,
            alt: ''
        },
    },
];

export const preProcessedAnalyticsTable: tableObject[] = [
    {
        text: '1. Normal Sea states (NSS)',
        link: {
            text: 'Normal Sea states (NSS).xlsx',
            href: noramlSeaStatesFile,
        },
        type: 'file',
    },
    {
        text: '2. Extreme Values (EVA)',
        link: {
            text: 'Extreme Values (EVA).xlsx',
            href: extreamValuesFile,
        },
        type: 'file',
    },
]
